package pwgs.ui.scenes.customstatscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(CustomStatSceneProps::class, CustomStatSceneModel::class)
interface CustomStat {
    fun load()
    fun refreshTodayStat()
}

@Serializable
data class CustomStatSceneProps(
    val projectId: Long,
    val statType: String,
    val statName: String,
    val prefix: String,
    val postfix: String,
    val divider: Int,
    val decimalDivider: Int,
    val decimalSeparator: String = "."
)

@Serializable
class CustomStatSceneModel(
    var todayStat: Map<String, Long>,
    val last30DayStat: List<CustomStatSceneItemModel>
)

@Serializable
class CustomStatSceneItemModel(
    val date: String,
    val values: Map<String, Long>
)